import { Typography } from "../../../../../../shared/frontend/ui";
import React from "react";
import { useAuth } from "../../app/auth/useAuth";
import { useI18n } from "../../app/i18n/useI18n";
import { areaAccessContextFromAuth, areaCards, salesArea } from "../../app/navigation/areaCatalog";
import { NavCardGrid } from "../../components/NavCardGrid";

const { Text } = Typography;

export function SalesHomePage() {
  const { text } = useI18n();
  const auth = useAuth();

  // Karten, Menü und Router-Guards lesen denselben Bereichskatalog.
  const items = React.useMemo(() => areaCards(salesArea, areaAccessContextFromAuth(auth.info)), [auth.info]);

  if (items.length === 0) {
    return (
      <NavCardGrid title={text("Sales")} text={text} empty={<Text type="secondary">{text("No permissions available")}</Text>} />
    );
  }

  return (
    <NavCardGrid title={text("Sales")} items={items} text={text} />
  );
}
